import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers, border } = baseVariables;

export const HeaderRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacers?.spacers?.[3]};
  block-size: 4.625rem;
  inline-size: 100%;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  &,
  &:hover,
  &:focus,
  &:active {
    border-block-start: ${border?.borderWidth02} ${border?.borderStyleDefault} var(--t-horizontal-vertical-rule);
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--t-brand-alt-color);
  }
`;

export const HeaderRowImage = styled.div<{ $widthPx: number }>`
  height: ${props => props.$widthPx / 2}px;
  overflow: hidden;
  flex: none;

  &,
  & .m-accordion-control-image {
    width: ${props => props.$widthPx}px;
  }
`;

export const HeaderRowText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  text-align: left;
`;
